import { ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { CommonService, ToasterService } from '../../../../services/common';
import { forkJoin, Subject, takeUntil } from 'rxjs';
import { SalesService } from '../../sales.service';
import { IconList } from '../../../../../iconlist';

@Component({
  selector: 'app-booking-pending-cancellation-list',
  templateUrl: './booking-pending-cancellation-list.component.html',
  styleUrl: './booking-pending-cancellation-list.component.scss'
})

export class BookingPendingCancellationComponent implements OnInit, OnChanges {
  bookingListData: any[] = [];
  showBookingCancellationDialogue: boolean = false;
  cancelledRowData: any;
  bookingCancellationApprovalDate = new Date();
  maxDate: Date = new Date();
  approvalRejectionReason: any = '';
  bookingApprovalRejection: boolean = false;

  // Cancellation modal properties
  showEditCancellationModal: boolean = false;
  editModalMode: 'edit' | 'create' = 'edit';

  initials: any;
  selectedExportData: any[] = [];
  projectId: any;
  columnDefs: any[] = [];
  rowStyles: any[] = [];

  // Flag to prevent multiple concurrent API calls
  isProcessing: boolean = false;

  approveIcon: string = 'assets/images/' + IconList.ApprovedIcon;
  rejectIcon: string = 'assets/images/' + IconList.RejectedIcon;
  editIcon: string = 'assets/images/' + IconList.EditIconDropdown;
  cancelIcon: string = 'assets/images/' + IconList.AllotmentCancelIcon;

  private destroy$ = new Subject<void>();


  constructor(public commonService: CommonService, private toasterService: ToasterService, private salesService: SalesService, private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.getInitials();
    this.setColumnDefs();
    this.getBookingsPendingForCancellation();
  }

  ngOnChanges(changes: SimpleChanges): void {

  }

  setColumnDefs() {
    this.columnDefs = [
      // @ts-ignore
      {

        field: 'selection', columnType: 'checkbox'
      },
      {
        header: 'Booking #', field: 'id', columnType: 'text'
      },
      {
        header: 'Client Name', field: 'clientName', columnType: 'text'
      },
      {
        header: 'Agent Name', field: 'sourceName', columnType: 'text'
      },
      {
        header: 'Unit Category',
        field: 'product',
        columnType: 'text',

      },
      {
        header: 'Amount',
        field: 'amount',
        columnType: 'text'
      },
      {
        header: 'Received Amount',
        field: 'recivedAmount',
        columnType: 'text'
      },
      {
        header: 'Status',
        field: 'status',
        columnType: 'text'
      },
      {
        header: 'Actions', field: 'action', columnType: 'dropdown', options: [
          { label: 'Approve', value: 'approve', icon: this.approveIcon },
          { label: 'Reject', value: 'reject', icon: this.rejectIcon },
          { label: 'Edit', value: 'edit', icon: this.editIcon },
          { label: 'Cancel Request', value: 'cancelRequest', icon: this.cancelIcon }
        ]
      }
    ];
  }


  /**
   * Get cancelled bookings list
   */
  getBookingsPendingForCancellation() {
    this.commonService.selectedProjects$
      .pipe(takeUntil(this.destroy$)).subscribe((selectedProject: any) => {
        this.bookingListData = [];
        if (selectedProject != null) {
          this.projectId = selectedProject?.id;
          forkJoin([this.salesService.getFilterBookings(this.projectId, null, null, null, null, true)
          ]).subscribe(([pendingBooking]) => {
            const bookings = pendingBooking?.result || [];
            this.bookingListData = bookings?.map((data: any) => {
              let formattedAmount: string = data?.amount?.toLocaleString('en-IN');
              data.amount = formattedAmount;
              data.originalAmount = formattedAmount?.replaceAll(',', '');
              let formattedReceivedAmount = data?.recivedAmount?.toLocaleString('en-IN');
              data.recivedAmount = formattedReceivedAmount;
              let sourceNameinitial: any = this.initials?.find(
                (initial: any) => initial?.id == data?.sourceDetail?.nameInitialsId
              );
              if (data.clientDetail) {
                data.clientName = data?.clientDetail?.nameInitialsName + '.' + ' ' + data?.clientDetail?.firstName + ' ' + data?.clientDetail?.lastName;
              }
              data.contactNumber = data?.clientDetail?.primaryPhoneNo?.replace(/(\d{5})(\d{5})/, '$1-$2');
              if (data.sourceDetail) {

                data.sourceName =
                  (sourceNameinitial ? sourceNameinitial?.name + '. ' : '') +
                  data?.sourceDetail?.firstName +
                  ' ' +
                  data?.sourceDetail?.lastName;
              }
              if (data?.unitCategoryDetail) {
                data.product = data?.unitCategoryDetail?.name;
              }
              if (data.isRequestedForCancellation) {
                data.status = "Pending For Approval";
              }
              if (data.isCancelled) {
                data.status = "Cancelled";
              }

              return data;
            });

          }, error => {
            console.error('Error:', error);
          });
        }
      });
  }

  /**
 * Get name initials for a customer name
 */
  getInitials() {
    this.salesService.getInitials().then((res: any) => {
      if (res) {
        this.initials = res?.result;
      }
    });
  }

  onCommonTableDropdownChange(event: { route: any, currentRow: any }): void {
    if (this.isProcessing) return; // Prevent multiple concurrent operations

    const action = event.route;
    this.cancelledRowData = event.currentRow;

    switch (action) {
      case 'approve':
        this.bookingApprovalRejection = true;
        this.showBookingCancellationDialogue = true;
        break;
      case 'reject':
        this.bookingApprovalRejection = false;
        this.showBookingCancellationDialogue = true;
        break;
      case 'edit':
        this.openEditCancellationModal();
        break;
      case 'cancelRequest':
        this.cancelCancellationRequest();
        break;
    }
  }

  /**
   * Submit cancellation status to approve/reject the booking cancellation request
   */
  submitCancellationStatus() {
    if (this.isProcessing) return; // Prevent multiple concurrent calls

    //First get the data of current booking cancellation request so that we can verify the booking approval/rejection date
    //is not prior to the booking cancellation request date. and reqestor and approver should not be same.
    this.isProcessing = true;
    this.salesService.GetBookingCancellationDetails(this.cancelledRowData.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res) => {
          if (res && res.result) {
            //proceed with approval/rejection
            var cancellationApprovalData = {
              isApproved: this.bookingApprovalRejection,
              approvedRejectedBy: this.commonService.getLoggedInUserId(),
              approvedRejectedOn: this.bookingCancellationApprovalDate,
              approverRemark: this.approvalRejectionReason
            }

            this.salesService.ApproveRejectBookingCancellation(this.cancelledRowData.id, cancellationApprovalData)
              .pipe(takeUntil(this.destroy$))
              .subscribe({
                next: (res) => {
                  var status = this.bookingApprovalRejection ? 'approved' : 'rejected';
                  this.toasterService.showSuccess('Booking cancellation ' + status + ' successfully.');
                  //reset the dialogue data
                  this.cancelledRowData = null;
                  this.bookingCancellationApprovalDate = new Date();
                  this.approvalRejectionReason = '';
                  this.bookingApprovalRejection = false;
                  this.showBookingCancellationDialogue = false;

                  //refresh the booking list (pending for cancellation)
                  this.getBookingsPendingForCancellation();
                },
                error: (err) => {
                  this.toasterService.showError(err?.error?.message || 'Failed to approve/reject cancellation.');
                },
                complete: () => {
                  this.isProcessing = false;
                }
              });
          }
        },
        error: (err) => {
          this.toasterService.showError(err?.error?.message || 'Failed to fetch booking cancellation details.');
          this.isProcessing = false;
        }
      });
  }

  /**
   * Open edit cancellation modal to edit existing cancellation request details
   */
  openEditCancellationModal(): void {
    // Just open modal with booking record - modal will fetch cancellation details in edit mode
    this.editModalMode = 'edit';
    this.showEditCancellationModal = true;
  }

  /**
   * Handle modal close without submission
   */
  onEditCancellationModalClose(): void {
    this.showEditCancellationModal = false;
    this.cancelledRowData = null;
    this.editModalMode = 'edit';
  }

  /**
   * Handle edit cancellation successful submission
   */
  onEditCancellationFormSubmit(event: any): void {
    // Modal has already called the API and shown success message
    // Just refresh the list and close modal
    this.showEditCancellationModal = false;
    this.cancelledRowData = null;
    this.editModalMode = 'edit';
    this.getBookingsPendingForCancellation();
  }

  /**
   * Cancel the cancellation request by resetting isRequestedForCancellation flag to false
   * This calls a dedicated endpoint that resets the request without checking approver/requester conflict
   */
  cancelCancellationRequest(): void {
    if (this.isProcessing) return; // Prevent multiple concurrent calls

    if (confirm('Are you sure you want to cancel this cancellation request? This will reset the booking status.')) {
      this.isProcessing = true;
      this.salesService.CancelBookingCancellationRequest(this.cancelledRowData.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res) => {
            this.cancelledRowData = null;
            this.toasterService.showSuccess('Cancellation request cancelled successfully. Booking status has been reset.');
            this.getBookingsPendingForCancellation();
          },
          error: (err) => {
            this.toasterService.showError(err?.error?.message || 'Failed to cancel the cancellation request.');
          },
          complete: () => {
            this.isProcessing = false;
          }
        });
    }
  }

  onSelectedRowsChange($event: any): void {
    this.selectedExportData = $event;
  }

  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
